
import React from "react";
import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@shared/ui/dialog";

interface FieldForceAddModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onRedirect: () => void;
}

const FieldForceAddModal: React.FC<FieldForceAddModalProps> = ({
  isOpen,
  onOpenChange,
  onRedirect,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add New Technician</DialogTitle>
          <DialogDescription>
            Would you like to add a new field technician to your team?
          </DialogDescription>
        </DialogHeader>
        <div className="py-6">
          <p className="text-sm text-muted-foreground">
            Adding a new technician will take you to a form where you can enter all the necessary details for onboarding.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onRedirect}>Continue</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FieldForceAddModal;
